module.exports = __webpack_public_path__ + "img/ca-selected.c9389986.svg";